import { Component } from '@angular/core';

@Component({
    selector: 'intro',
    templateUrl: 'intro.component.html',
    styleUrls: ['intro.component.scss'],
    standalone: false
})
export class IntroComponent {}
